import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    offsetForPagination: Boolean
  }
  connect() {
    document.addEventListener('turbo:load', this.resetZendeskChat)

    window.zESettings ||= { webWidget: {} }
    window.zESettings.webWidget.authenticate = {
      chat: {
        jwtFn: function (callback) {
          fetch('/api/zendesk/chat_token.json')
            .then(response => response.json())
            .then(json => callback(json.token))
            .catch(error => console.error(error))
        }
      }
    }
  }

  disconnect() {
    document.removeEventListener('turbo:load', this.resetZendeskChat)
  }

  resetZendeskChat = () => {
    if (this.offsetForPaginationValue) {
      window.zESettings.webWidget.offset = { vertical: '65px', mobile: { vertical: '65px' } }
    } else {
      window.zESettings.webWidget.offset = {}
    }
    if (window.zEACLoaded) window.zEACLoaded = false
  }
}
